import gql from "graphql-tag";

export const quoteDetailFieldsFragment = gql`
    fragment quoteDetailFields on QuoteDetail {
        id,
        partId,
        quoteId,
        description,
        total,
        vat,

    }
    `